import React from 'react';
import {  Collapse} from 'reactstrap';
import moment from 'moment';
import StorageGateway from 'lib/storage-gateway';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { Popover } from 'reactstrap';
import Dropdown from 'reactstrap/lib/Dropdown';
import DropdownToggle from 'reactstrap/lib/DropdownToggle';
import DropdownMenu from 'reactstrap/lib/DropdownMenu';
import DropdownItem from 'reactstrap/lib/DropdownItem';
import JobFilterFormComponent from 'components/common/JobFilterForm';
import SortHeaderComponent from './QuotedProjectSortHeaderComponent';
import JobAdvancedFilterForm from './JobAdvancedFilters';
import AttributeToggler from "employees/components/AttributeToggler";
import JobCostingSummary from './JobCostingSummary.jsx';
import { UncontrolledTooltip, Tooltip } from 'reactstrap';

import ButtonLoaderAtom from 'atoms/ButtonLoader';
import ViewIconAtom from "atoms/JobViewIcon";
import {ReactComponent as SortIcon} from './sort.svg';
import Button from 'reactstrap/lib/Button';
import ReactTable from "react-table";
import { FILTER_OPTIONS , ADVANCE_GROUP_BY_OPTIONS} from 'constants/jobs';
import caretArrowUp from './caret-arrow-up.png';
import reload from './reloading.png';
import showHideIcon from './showHideIcon.png'
import jobNotes from './jobNotes.png'
import jobNotesDisable from './jobNotesDisable.png'
import cookie from 'react-cookies';

import styles from './styles.module.scss';
/**

 * JobListPage -> JobListSection -> `CustomerListTableComponent`
 *
 * Props:
 *    - employee list
 */

class QuotedProjectCustomerTable extends React.Component {
  constructor(props) {
    super(props);
    this.updateState = this.updateState.bind(this);
    this.pageChange = this.pageChange.bind(this);
    this.pageSizeChange = this.pageSizeChange.bind(this);
    this.setData = this.setData.bind(this);
    this.search = this.search.bind(this);
    this.dropdownToggle = this.dropdownToggle.bind(this);
    this.onStatusSelection = this.onStatusSelection.bind(this);
    this.toggle= this.toggle.bind(this);
    this.goTo = this.goTo.bind(this);
    this.setAttributeToggler = this.setAttributeToggler.bind(this);
    this.setAttributes = this.setAttributes.bind(this);
    this.setColumns = this.setColumns.bind(this);
    this.saveOrdering = this.saveOrdering.bind(this);
    this.getResized = this.getResized.bind(this);
    this.popToggle = this.popToggle.bind(this);
    this.isToolTipOpen = this.isToolTipOpen.bind(this);
    this.getEmployeeList = this.getEmployeeList.bind(this);
    this.applyAdvancedFilters = this.applyAdvancedFilters.bind(this);
    this.getTaskList = this.getTaskList.bind(this);
    this.toggleTable = this.toggleTable.bind(this);
    this.getTagsList = this.getTagsList.bind(this);
    this.toggleSummary = this.toggleSummary.bind(this);
    this.getTrProps = this.getTrProps.bind(this);
    this.getTdProps=this.getTdProps.bind(this);
    this.prevJobId = null;
    this.prevTaskId = null;
    this.prevEmployeeId= null;
    this.resultemployee = [];
    this.resultTask = [];
    this.advancedFlters = null;
    this.accessorToHeader = {
      customer_name: "Customer",
      code : "Job Code",
      name: "Job",
      start_date: "Start Date",
      end_date: "End Date",
      employee: "Employees",
      task_count: "Task",
      tags_count: "Tags Count",
      hours: "Actual Hours",
      total_budget_hour: "Budgeted Hours",
      total_quoted_amount: "Quoted Amount",
      labour_cost: "Labor Cost",
      labour_ratio: "Labor Ratio",
      status: "Status"
    };
    this.widthToHeader = {
      customer__customer_name: 140,
      code : 140,
      name: 140,
      start_date: 140,
      end_date: 140,
      employee_count: 140,
      task_count: 140,
      tags_count: 140,
      hours: 140,
      total_budget_hour: 140,
      total_quoted_amount: 140,
      labour_cost: 140,
      labour_ratio: 140,
      status: 140,
      view: 140,
    };
    this.state = {
      loading: false,
      currentPage: 0,
      tableView: null,
      currentPageSize: 10,
      pageChange : false,
      pageSize : null,
      dropdownOpen : false,
      valueStatus: { value: '', label: "Open"},
      selectedId : null,
      attributeToggler: false,
      showableAttributes: cookie.load('showableAttributesProject') || {},
      userViewPreferenceLoading: false,
      isEmployeeLoading: false,
      isTaskLoading: false,
      isSummaryView: false
    };
  }



  componentWillMount() {
    const { router: { history } } = this.context;
    const { location: { query , pathname }, userProfile } = this.props;
    const uniqueUuid = StorageGateway.get('uniqueUuid');
    const widthChange = cookie.load(`projectTableWidth${uniqueUuid}${userProfile.company.id}`);
    if(widthChange){
      this.widthToHeader=widthChange;
      if(this.widthToHeader.view && this.widthToHeader.view < 140){
        this.widthToHeader.view = 140;
        cookie.save(`projectTableWidth${uniqueUuid}${userProfile.company.id}`,this.widthToHeader, { path: '/'});
      }
    }
    const advancedFlters =  StorageGateway.get(`quotedProjectFiltersCookie${uniqueUuid}${userProfile.company.id}`); 
    
    this.advancedFilters = advancedFlters ? JSON.parse(advancedFlters) : {};
    if((this.advancedFilters && !this.advancedFilters.quotedProjectFiltersCookiedate_range) || !this.advancedFilters){
      this.advancedFilters['quotedProjectFiltersCookiedate_range'] = {label: "This Month" , value: "4"}
    }
    if((this.advancedFilters && !this.advancedFilters.quotedProjectFiltersCookiestatus)){
      this.advancedFilters['quotedProjectFiltersCookiestatus'] = {value : "1",label : "Open"}
    }

    StorageGateway.set(`quotedProjectFiltersCookie${uniqueUuid}${userProfile.company.id}`, JSON.stringify(this.advancedFilters));

    this.props.getUserPreference({bill_type: 'QUOTED', job_type: 'PROJECT'})
    .then(() => {
      const {userViewPreferenceQuotedProject} = this.props;
      let obj = {}
      let all_fields =userViewPreferenceQuotedProject.all_fields;
      let show_fields = userViewPreferenceQuotedProject.show_fields;
      all_fields.forEach(v => {
        if(show_fields.indexOf(v)!== -1) {
          obj[v] = true;
        }
        else {
          obj[v] = false;
        }
      }
      )
      this.setAttributes(obj);
      cookie.save("pageSizeProject", userViewPreferenceQuotedProject.page_size, { path: '/'});
      cookie.save("projectSorting", userViewPreferenceQuotedProject.default_ordering, { path: '/'});
      const pageSizeCookie = cookie.load('pageSizeProject');
      if(pageSizeCookie){
        this.setState({currentPageSize: pageSizeCookie});
      } else {
        this.setState({currentPageSize: 10});
      }
    })
    .catch(() => {
      let attributes = {};
      for (const acc in this.accessorToHeader) {
        if(acc === 'labour_ratio')
        {
          attributes[acc] = false;
        }
        else
        {
          attributes[acc] = true;
        }
      }
      this.setAttributes(attributes);
    });
    this.props.openAccordian();
  }

  search(){
    const { quotedRecurringSearch } = this.state;
    this.setState({quotedRecurringSearch : !quotedRecurringSearch});
  }

  toggleTable(key, tableData){
    const { userProfile } = this.props;
    const uniqueUuid = StorageGateway.get('uniqueUuid');
    const advancedFlters =  StorageGateway.get(`quotedProjectFiltersCookie${uniqueUuid}${userProfile.company.id}`); 
    
    this.advancedFilters = advancedFlters ? JSON.parse(advancedFlters) : {};
    if((this.advancedFilters && !this.advancedFilters.quotedProjectFiltersCookiedate_range) || !this.advancedFilters){
      this.advancedFilters['quotedProjectFiltersCookiedate_range'] = {label: "This Month" , value: "4"}
    }
    if((this.advancedFilters && !this.advancedFilters.quotedProjectFiltersCookiedstatus)){
      this.advancedFilters['quotedProjectFiltersCookiestatus'] = {value : "1",label : "Open"}
    }

    StorageGateway.set(`quotedProjectFiltersCookie${uniqueUuid}${userProfile.company.id}`, JSON.stringify(this.advancedFilters));
    this.props.toggleAccordian(key, tableData);
  }

  getTrProps(state, rowInfo, instance){
    if (rowInfo && rowInfo.original && rowInfo.original.total) {
      return {
        style: {
          background: '#E2ECF1',
          fontWeight: 'bold',
        }
      }
    }
    return {};
  }

   getTdProps(state, rowInfo, col, instance){
    if (rowInfo && rowInfo.original && rowInfo.original.total) {
      return {
        style: {
          height:'auto',
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center'
        }
      }
    }
    return {};
  }

  componentWillUnmount(){
    cookie.save('Projectpage',  1, { path: '/'})
  }

  componentWillReceiveProps(nextProps){
    const { location: { query } } = this.props;
    const { location: { search } } = nextProps;
    const ProjectpageCookie=cookie.load("Projectpage");
    const { currentPage } = this.state;
    const nextQuery = queryString.parse(search);
    if(query.project_search !== nextQuery.project_search){
      this.setState({currentPage : 0});
    }
    if(query.project_sorting !== nextQuery.project_sorting && nextQuery.project_sorting && this.state.showableAttributes.name){
      this.saveOrdering(nextQuery);
    }
    if( JSON.stringify(nextProps.quotedProjectList) !== JSON.stringify(this.props.quotedProjectList)){
      let temp = {...this.state.associatedEmployees};
      nextProps.quotedProjectList.forEach((item, index)=> {
        temp[`project${index}`] = 'Loading...';
      });
      this.setState({associatedEmployees : temp});
    }
    if( JSON.stringify(nextProps.quotedProjectList) !== JSON.stringify(this.props.quotedProjectList)){
      let temp = {...this.state.associatedTasks};
      nextProps.quotedProjectList.forEach((item, index)=> {
        temp[`project${index}`] = 'Loading...';
      });
      this.setState({associatedTasks : temp});
    }
    if( JSON.stringify(nextProps.quotedProjectList) !== JSON.stringify(this.props.quotedProjectList)){
      let temp = {...this.state.associatedTags};
      nextProps.quotedProjectList.forEach((item, index)=> {
        temp[`project${index}`] = 'Loading...';
      });
      this.setState({associatedTags : temp});
    }
  }


  setData(params,total) {
    const { router: { history } } = this.context;
    const { location: { query }, quotedProjectList , userProfile } = this.props;
    const uniqueUuid = StorageGateway.get('uniqueUuid');
    const cookieKey = cookie.load('tableView');
    let jobData;
    let detail = "";
    
    let projectAdvancedFilterCookie = StorageGateway.get(`quotedProjectFiltersCookie${uniqueUuid}${userProfile.company.id}`);
    projectAdvancedFilterCookie = projectAdvancedFilterCookie && JSON.parse(projectAdvancedFilterCookie);
    let dates = this.props.setStartAndEndDate(projectAdvancedFilterCookie['quotedProjectFiltersCookiedate_range'] && projectAdvancedFilterCookie['quotedProjectFiltersCookiedate_range'].label , projectAdvancedFilterCookie['quotedProjectFiltersCookiestart_date'], projectAdvancedFilterCookie['quotedProjectFiltersCookieend_date'] )


    if(cookieKey.quotedProject === true) {
      jobData =  quotedProjectList.find(obj => {
        return obj.id === params.data.id
      });
    }

    if(total){
      detail = {
        start_date: moment(dates.start_date).toISOString(),
        end_date: moment(dates.end_date).toISOString(),
        group_by: params && params.group_by,
        jobs : params.data && params.data.pks &&  params.data.pks.length && params.data.pks.map((i)=> {return {name : i.name , id : i.pk}})
      }
    }
    else{
      detail = {
        jobs: [{ id: jobData.id, name: jobData.name }],
        start_date: moment(dates.start_date).toISOString(),
        end_date: moment(dates.end_date).toISOString(),
        group_by: params && params.group_by,
        customers: jobData.customer_data && jobData.customer_data.id ? [jobData.customer_data] : null,
        tasks: params && params.task && params.task.id ? [{ id: params.task.id, name: params.task.name }] : null
      };
    }
    this.props.setJobReportsData(detail);
    history.push( '/job/lists/jobreports/');
  }

  popToggle(targetName){
    if (!this.state[targetName]) {
      this.setState({
        ...this.state,
        [targetName]: {
          tooltipOpen: true
        }
      });
    } else {
      this.setState({
        ...this.state,
        [targetName]: {
          tooltipOpen: !this.state[targetName].tooltipOpen
        }
      });
    }
  };

  isToolTipOpen(targetName) {
    return this.state[targetName] ? this.state[targetName].tooltipOpen : false;
  };

  goTo(url) {
    const { router: { history } } = this.context;
    history.push(url);
  }

  getEmployeeList(jobId, index){
    let results = [];
    const { associatedEmployees } = this.state;
    if(this.prevEmployeeId !== `project${index}` && associatedEmployees[`project${index}`] == 'Loading...'){
      this.props.setEmployee({job_id: jobId, assigned: true})
      .then((res)=>{
          let temp = {...this.state.associatedEmployees };
          res.value.forEach((item, index)=>
          results.push(item.user.full_name));
          temp[`project${index}`] = results;
          this.setState({associatedEmployees : temp});
          this.prevEmployeeId = `project${index}`;
    });}
  }


  getTagsList(jobId, index){
    let results = [];
    const { associatedTags } = this.state;
    if(this.prevJobId !== `project${index}` &&  associatedTags[`project${index}`] && associatedTags[`project${index}`] == 'Loading...'){
      this.props.setTags({job_id: jobId, assigned: true})
      .then((res)=>{
          let temp = {...this.state.associatedTags };
          res && res.value && res.value.tags && res.value.tags.length && res.value.tags.forEach((item, index)=>
          results.push(item));
          temp[`project${index}`] = results;
          this.setState({associatedTags : temp});
          this.prevJobId = `project${index}`;
    });}
  }


  getTaskList(jobId, index){
    let results = [];
    const { associatedTasks } = this.state;
    if(this.prevTaskId !== `project${index}` && associatedTasks[`project${index}`] == 'Loading...'){
      this.props.setTask({job_id: jobId, assigned: true})
      .then((res)=>{
        let temp = {...this.state.associatedTasks };
         res.value.forEach((item, index)=>
          results.push(item.name)
        ) 
        temp[`project${index}`] = results;
        this.setState({associatedTasks : temp});
        this.prevTaskId = `project${index}`;      
      })
    }
  }

  saveOrdering(nextQuery) {
    const showFields = Object.keys(this.state.showableAttributes).filter((item) => {
      if(this.state.showableAttributes[item] === true)
        return item
      else if(this.state.showableAttributes[item] === false && item === "name")
        return true
      else
        return false
    })
    const pageSize = cookie.load("pageSizeProject") || 10;
    const preferenceObj = {
      all_fields : Object.keys(this.accessorToHeader),
      show_fields: showFields,
      page_size: pageSize,
      bill_type: 'QUOTED',
      job_type: 'PROJECT',
      default_ordering : nextQuery.project_sorting
    }
    this.props.setUserPreference(preferenceObj)
    cookie.save("projectSorting", nextQuery.project_sorting, { path: '/'});
  }



   onStatusSelection(val, id){
    if(val){
      this.setState({valueStatus: val, selectedId: id});
    }
    else{
      this.setState({valueStatus:""});
    }
  }


  applyAdvancedFilters(params){
    const { getJobList } = this.props;
    cookie.save('Projectpage',  1, { path: '/'})
    this.setState({ currentPage: 0 });
    return getJobList(this.props , this.state.tableData, 'project_search' , params);
  }


  dropdownToggle() {

    const { dropdownOpen } = this.state;
    this.setState({dropdownOpen: !dropdownOpen});
  }



  pageChange(item) {
    cookie.save('Projectpage', (+item) + 1, { path: '/'})
    this.setState({ currentPage: item });

  }

  togglePopOver(id, item){
    const { PopOverOpen } = this.state;
    this.setState({ PopOverOpen : !PopOverOpen, selectedItem: item})
  }



  pageSizeChange(pageSize, pageIndex) {
    cookie.save('pageSizeProject', pageSize, { path: '/'});
    cookie.save('Projectpage',  1, { path: '/'})
    this.setState({ currentPageSize: pageSize, currentPage: 0 });
    this.setColumns('submit');
  }


  toggle(){
    this.setState({ currentPage: 0, currentPageSize: 10 });
   }



  updateState(key, value) {
    this.setState({
      [key]: value,
    });
  }

  setAttributeToggler(bool) {
    this.setState({ attributeToggler: bool });
    if(bool) {
      this.setState({ userViewPreferenceLoading: true})
      this.props.getUserPreference({bill_type: 'QUOTED', job_type: 'PROJECT'})
      .then(() => {
        const {userViewPreferenceQuotedProject} = this.props;
        let obj = {}
        let all_fields =userViewPreferenceQuotedProject.all_fields;
        let show_fields = userViewPreferenceQuotedProject.show_fields;
        all_fields.forEach(v => {
          if(show_fields.indexOf(v)!== -1) {
            obj[v] = true;
          }
          else {
            obj[v] = false;
          }
        }
        )
        this.setAttributes(obj);
        this.setState({ userViewPreferenceLoading: false});
      })
      .catch((err) => {
        this.setState({ userViewPreferenceLoading: false});
        let attributes = {};
        for (const acc in this.accessorToHeader) {
        if(acc === 'labour_ratio')
        {
          attributes[acc] = false;
        }
        else
        {
          attributes[acc] = true;
        }
      }
        this.setAttributes(attributes);
      })
    }else{
      const {userViewPreferenceQuotedProject} = this.props;
      let obj = {}
      let all_fields =userViewPreferenceQuotedProject.all_fields;
      let show_fields = userViewPreferenceQuotedProject.show_fields;
      all_fields.forEach(v => {
        if(show_fields.indexOf(v)!== -1) {
          obj[v] = true;
        }
        else {
          obj[v] = false;
        }
      }
      )
      this.setAttributes(obj);
    }
  }

  async setAttributes(attributes) {
    await this.setState({ showableAttributes: attributes });
    cookie.save("showableAttributesProject", attributes, { path: '/'})
  }

  setColumns(submit) {
    const showFields = Object.keys(this.state.showableAttributes).filter((item) => {
      if(this.state.showableAttributes[item] === true)
        return item
      else if(this.state.showableAttributes[item] === false && item === "name")
        return true
      else
        return false
    })
    const pageSize = cookie.load("pageSizeProject") || 10;
    const preferenceObj = {
      all_fields : Object.keys(this.accessorToHeader),
      show_fields: showFields,
      page_size: pageSize,
      bill_type: 'QUOTED',
      job_type: 'PROJECT',
    }
    this.props.setUserPreference(preferenceObj)
    .then(() => {
      if(!submit) this.setState({attributeToggler: !this.state.attributeToggler})
    })
  }

  getResized(newSize){
    const {userProfile} = this.props;
    const uniqueUuid = StorageGateway.get('uniqueUuid');
    newSize.map((item,index)=>{
      this.widthToHeader[item.id]=item.value;
    })
    cookie.save(`projectTableWidth${uniqueUuid}${userProfile.company.id}`,this.widthToHeader, { path: '/'});
  }

  toggleSummary(){
    const {isSummaryView} = this.state;
    this.setState({isSummaryView:!isSummaryView});
  }

  render() { 
    const { location, goTo, pageQuotedProjected, getJob,
      saveStatus, isStatusLoading, toggle, originalCount, exportCSV, exportQuotedProject, isLoadingProject, quotedProject, toggleAccordian, quotedProjectList, refresh, PopOverOpen, selectedItem, disclaimerModalToggle} = this.props;
    const { query } = location;
    const {  currentPage, currentPageSize , dropdownOpen, valueStatus, selectedId, isSummaryView} = this.state;
    let updatedQuotedProject = quotedProjectList.map(item => {
      const s = item.status && FILTER_OPTIONS.filter(i => i.value === item.status)[0].label;
      return { ...item, status: s };
    });
    updatedQuotedProject = updatedQuotedProject.filter(item => item.status || item.total)
    return(
      <div>
        <div className={quotedProject? styles['card-header']: [styles['card-header--closed'], styles['card-header']].join(' ')}>
          <div 
            className={styles['card-header__label--quoted']} 
            onClick={() => this.toggleTable("quotedProject",this.props.tableData)}>
              <p className={styles['card-header__p']} style={{marginBottom: '1rem'}}>Quoted Project</p>
              <img alt=""
                src={caretArrowUp} 
                className={
                  quotedProject? styles['card-header__label--quoted--down']: styles['card-header__label--quoted--up']} 
                  height="10" 
              />
          </div>
          {
            quotedProject &&
            <div className={styles['card-header__search-bar']}>
                <JobFilterFormComponent 
                  location={location} 
                  id="project_search"
                  placeholder="Job Name and Job Code" 
                  initialValues={{...query}}
                  projectSearchCookie="project_search"
                />
            </div>
          }
          { 
            quotedProject &&
            <Button
              color="primary"
              onClick={() => this.setAttributeToggler(!this.state.attributeToggler)}
              className={styles['show-hide-button-custom']}
              >
              <div id="show_hide">
                <img
                  className={styles['button-icon']}
                  src={showHideIcon}
                  alt="Icon"
                />
                <UncontrolledTooltip placement="top" target="show_hide">
                  Show/Hide
                </UncontrolledTooltip>
              </div>
            </Button>
          }
          <div className={styles['card-header__btn']}>
            { quotedProject &&
              <Button
                color="primary"
                id="add_job"
                onClick={() => exportCSV(this.props.tableData, "quotedProject", this.state.showableAttributes)}
                disabled={updatedQuotedProject && !updatedQuotedProject.length}
              >
                Export <ButtonLoaderAtom active={exportQuotedProject} />
              </Button>
            }
            { quotedProject &&
              <Button
                color="primary"
                className="align-top ml-2"
                onClick={() => this.goTo({
                  pathname: '/job/list/bulk-upload',
                  search: queryString.stringify({
                    type: 'quotedProject',
                  })
                })}
              >
                Bulk Upload
              </Button>
            }
          </div>
          {this.state.attributeToggler &&
            <AttributeToggler
              setToggle={() => this.setAttributeToggler(!this.state.attributeToggler)}
              toggle={this.state.attributeToggler}
              data={{
                labels: Object.values(this.accessorToHeader),
                accessors: Object.keys(this.accessorToHeader),
                defaultVals: Object.values(this.state.showableAttributes)
              }}
              onChange={this.setAttributes}
              mandatoryField = 'name'
              setColumns={this.setColumns}
              isLoading={this.state.userViewPreferenceLoading}
            />
          }
        </div>
        {quotedProject && (!isLoadingProject) &&
          <div style={{border:'none', paddingLeft: '1.4rem', position: 'relative', marginTop:'-10px', justifyContent:'space-between'}} className={quotedProject? styles['card-header']: [styles['card-header--closed'], styles['card-header']].join(' ')}>
            <p style={{float: "left"}}>Total: {quotedProject ? this.props.totalRecords : originalCount} Records</p>
            <div className="d-flex">
              {this.props.quotedProjectSummaryData && this.props.quotedProjectSummaryData.scenario_meta ?
                <p style={{fontWeight : 'bold'}} className="mt-3">Analytics last updated:{this.props.quotedProjectSummaryData && this.props.quotedProjectSummaryData.scenario_meta && this.props.quotedProjectSummaryData.scenario_meta.created_at_display}</p> : null
              }
              {quotedProject && 
                <p className={styles['last-update-refresh-button']}>
                  <Button
                    color="primary"
                    onClick={() => disclaimerModalToggle('quotedProject')}
                  >
                    <img alt="refresh" src={reload} width="15" height="15" className={`${styles['refresh-icon']}`} />
                    Update
                  </Button>
                </p>
              }
            </div>
          </div>
        }
        {quotedProject &&
          <div style={{border:'none', paddingLeft: '1.1rem', paddingBottom: '0.8rem', position: 'relative'}} className={quotedProject? styles['card-header']: [styles['card-header--closed'], styles['card-header']].join(' ')}>
            <JobAdvancedFilterForm
              getCustomers={this.props.getCustomers}
              customerList={this.props.customerList}
              getEmployees={this.props.getEmployees}
              employeeList={this.props.employeeList}
              getJobs = {this.props.getJobs}
              form="form1"
              jobsAndCodesList={this.props.jobsAndCodesList}
              getJobTags={this.props.getJobTags}
              jobTagList={this.props.jobTagList}
              getTasks={this.props.getTasks}
              TasksAndCodesList={this.props.TasksAndCodesList}
              getTaskTags={this.props.getTaskTags}
              taskTagList={this.props.taskTagList}
              applyAdvancedFilters = {this.applyAdvancedFilters}
              initialValues = {this.advancedFilters}
              advancedFilterCookie = {'quotedProjectFiltersCookie'}
              dateFormat= {this.props.dateFormat}
              sortJobCodes={this.props.sortJobCodes}
              dateFormatDisplay={this.props.dateFormatDisplay}
              getEmployeeTags= {this.props.getEmployeeTags}
              employeeTagsList={this.props.employeeTagsList}
              userProfile={this.props.userProfile}
              location={location}
              key='quotedProjectFiltersCookie'
              showableAttributes={this.state.showableAttributes}
            />
          </div>
        }
        {quotedProject &&
          <div className={styles['card-header__summary_block']} style={{paddingBottom:'10px'}}>
            <span
              className={`${styles['card-header__label--quoted']} ${styles['card-header__summary_label']}`} 
              onClick={() => this.toggleSummary()}>
                <p className={styles['card-header__p']}>Summary </p>
                <img 
                  alt=""
                  src={caretArrowUp} 
                  className={
                    isSummaryView? styles['card-header__label--quoted--down']: styles['card-header__label--quoted--up']} 
                    height="10" 
                />
            </span>
            <Collapse isOpen={isSummaryView} className={styles['card-header__summary_content_view']}>
              <div className='pl-2 pr-2 pb-2 pt-2'>
                <JobCostingSummary jobType={isSummaryView} summaryData={this.props.quotedProjectSummaryData} tableView='quotedProject'/>
              </div>
            </Collapse>
          </div>
        }
        <Collapse isOpen={quotedProject}>
          <ReactTable
            data={updatedQuotedProject.length ? updatedQuotedProject : []}
            noDataText="No Records Found"
            pages={pageQuotedProjected}
            onFetchData={(item)=>getJob("quotedProject", item)} 
            loading={isLoadingProject }
            pageSizeOptions= {[5, 10, 20, 25, 50, 100, 500, 1000]}
            onPageChange={this.pageChange}
            minRows={1}
            pageSize={currentPageSize}
            page= {this.state.currentPage}
            onPageSizeChange={this.pageSizeChange}
            className="text-center mb-3"
            style={{ background: '#FFF' ,maxHeight:'750px'}}
            getTrProps={this.getTrProps}
            getTdProps={this.getTdProps}
            manual
            onResizedChange={(newResized, event) => {
              this.getResized(newResized);
            }}
            columns={[
              {
                Header: "ACTION",
                width:this.widthToHeader.view,
                sortable: false,
                id: 'view',
                resizable : false,
                headerClassName: 'text-center',
                Cell: row => {
                  if(row.original.total == true){
                    row.styles['height']="auto";
                    row.styles['justifyContent']="center";
                    return (
                      <div id={`projectTotalRow${row.index}`} className={styles['total-row-ellipsis']}>
                        Total { row.original.group_key ? `For ${row.original.group_key}` : null }
                        {row.original.group_key && 
                          <UncontrolledTooltip placement="right" target={`projectTotalRow${row.index}`}>
                            Total { row.original.group_key ? `For ${row.original.group_key}` : null }
                          </UncontrolledTooltip>
                        }
                      </div>
                    );
                  }
                  if (row.original.start_date_display ) {
                    return (
                    <div className={styles["margin-eye"]}>
                      <div
                        className="d-inline mt-2"
                        role="button"
                        onClick={() => toggle(row.original,"view", "quotedProject")}
                        title="View Customers"
                      >
                        <ViewIconAtom />
                      </div>
                      <div
                        className="d-inline ml-1"
                        title="View Job Notes"
                      >
                        {row.original.has_notes ? 
                          <img
                            src={jobNotes}
                            role="button"
                            alt="Icon"
                            onClick={() => toggle(row.original,"jobnotes", "quotedProject")}
                            height="20"
                            width="20"
                          /> : 
                          <img
                            src={jobNotesDisable}
                            role="button"
                            onClick={() => toggle(row.original,"jobnotes", "quotedProject")}
                            alt="Icon"
                            height="20"
                            width="20"
                          />}
                      </div>
                    </div>
                    );
                  }
                  return null;
                }
              },
              {
                Header: row => {return (
                   <SortHeaderComponent project_sorting="customer__customer_name">CUSTOMER</SortHeaderComponent>
                  )},
                accessor: "customer__customer_name",
                width:this.widthToHeader.customer__customer_name,
                id: 'customer__customer_name',
                sortable: false,
                show: this.state.showableAttributes.customer_name,
                headerClassName: 'text-left pl-4',
                Cell: row => {
                  if(row.original.total == true){
                    return null;
                  }
                  return (<div
                    title={row.original.customer_data.customer_name}
                    className="text-ellipsis text-left pl-3"
                  >
                    <b role="button" onClick={() => goTo(`/customers/list/${row.original.customer_data.id}/details`)}>{ row.original.customer_data.customer_name }</b>
                  </div>)
                }
              },
              {
                Header: row => {return (
                  <SortHeaderComponent project_sorting="code">JOB CODE</SortHeaderComponent>
                )},
                accessor: "code",
                width: this.widthToHeader.code,
                sortable: false,
                id: "code",
                show: this.state.showableAttributes.code,
                headerClassName: 'text-left pl-4',
                Cell: row => {
                  if(row.original.total == true){
                    return null;
                  }
                  return (<div className='text-ellipsis text-left pl-3'
                  >
                    <div>{ row.original.code }</div>
                  </div>)
                }
              },
              {
                Header:row => {return (
                    <SortHeaderComponent project_sorting="name">JOB</SortHeaderComponent>
                  )},
                accessor: "name",
                width: this.widthToHeader.name,
                id: 'name',
                sortable: false,
                show: this.state.showableAttributes.name,
                headerClassName: 'text-left pl-4',
                Cell: row => {
                  if(row.original.total == true){
                    return null;
                  }
                  return (<div
                    title={row.original.name}
                    className="text-ellipsis text-left pl-3"
                  >
                    <b role="button"
                    onClick={() => goTo(`/job/list/${row.original.id}/edit`)}>{ row.original.name }</b>
                  </div>)
                }
              },
              {
                Header: row => {return (
                    <SortHeaderComponent project_sorting="start_date">START DATE</SortHeaderComponent>
                    )},
                accessor: 'start_date',
                sortable: false,
                id: 'start_date',
                width: this.widthToHeader.start_date,
                show: this.state.showableAttributes.start_date,
                headerClassName: 'text-left pl-4',
                Cell: row => {
                  if(row.original.total == true){
                    return null;
                  }
                  return <div className="text-left pl-3">{ row.original.start_date_display }</div>
                }
              },
              {
                Header: row => {return (
                    <SortHeaderComponent project_sorting="end_date">END DATE</SortHeaderComponent>
                    )},
                accessor: 'end_date',
                width: this.widthToHeader.end_date,
                sortable: false,
                id: 'end_date',
                show: this.state.showableAttributes.end_date,
                headerClassName: 'text-left pl-4',
                Cell: row => {
                  if(row.original.total == true){
                    return null;
                  }
                  return <div className="text-left pl-3">{ row.original.end_date_display }</div>
                }
              },
              {
                Header: row => {return (
                    <SortHeaderComponent project_sorting="employee_count">EMPLOYEES</SortHeaderComponent>
                    )},
                accessor: 'employee_count',
                width: this.widthToHeader.employee_count,
                sortable: false,
                id: 'employee_count',
                className:'employee-div',
                headerClassName: 'text-right pr-4',
                show: this.state.showableAttributes.employee,
                Cell: row => {
                    if(row.original.total == true){
                      return (
                        <div>{row.original.employee_count}</div>
                      );
                    }
                    return (
                    <div key={`empproject${row.index}`} className={`${styles['employee-div']} pr-4`}>
                      <div
                        tabIndex="0"
                        id={`empproject${row.index}`}
                        onMouseOver={()=>this.getEmployeeList(row.original.id,row.index)}
                        className={`hover-employee-tooltip-div link-name d-inline-block`}
                        style={{width:'20%', cursor:'default'}}
                      >
                        <b role="button" onClick={() => this.setData({ data: row.original })}>{row.original.employee_count}</b>
                        <Tooltip
                          placement="left"
                          isOpen={this.isToolTipOpen(`empproject${row.index}`)}
                          autohide={false} 
                          hideArrow={false}
                          target={`empproject${row.index}`}
                          toggle={() => this.popToggle(`empproject${row.index}`)}
                          className={`${styles['hover-employee-div']} hover-employee-tooltip`}
                        >
                          {
                          this.state.associatedEmployees && this.state.associatedEmployees[`project${row.index}`] && this.state.associatedEmployees[`project${row.index}`] !== 'Loading...' ?
                          this.state.associatedEmployees&&  this.state.associatedEmployees[`project${row.index}`] && this.state.associatedEmployees[`project${row.index}`].length ? this.state.associatedEmployees[`project${row.index}`].map((item,index)=>
                              <li>{item}</li>
                              )
                            :
                              <li>No records</li>
                           :
                           <li>{this.state.associatedEmployees && this.state.associatedEmployees[`project${row.index}`] ? this.state.associatedEmployees[`project${row.index}`] : null}</li>
                          }
                        </Tooltip>
                      </div>
                    </div>
                  );
                }
              },
              {
                Header: row => {return (
                    <SortHeaderComponent project_sorting="task_count">TASKS</SortHeaderComponent>
                    )},
                accessor: 'task_count',
                width: this.widthToHeader.task_count,
                sortable: false,
                id: 'task_count',
                className:'employee-div',
                show: this.state.showableAttributes.task_count,
                headerClassName: 'text-right pr-4',
                 Cell: row => {
                    if(row.original.total == true){
                      return (
                        <div>{row.original.task_count}</div>
                      );
                    }
                    return (
                    <div key={`taskproject${row.index}`} className={`${styles['employee-div']} pr-4`}>
                      <div
                        tabIndex="0"
                        id={`taskproject${row.index}`}
                        onMouseOver={()=>this.getTaskList(row.original.id,row.index)}
                        className={`hover-employee-tooltip-div link-name d-inline-block`}
                        style={{width:' 20%', cursor:'default'}}
                      >
                        <b role="button" onClick={() => this.setData({ data: row.original, group_by: "task" })}>{row.original.task_count}</b>
                        <Tooltip
                          placement="left"
                          isOpen={this.isToolTipOpen(`taskproject${row.index}`)}
                          autohide={false} 
                          hideArrow={false}
                          target={`taskproject${row.index}`}
                          toggle={() => this.popToggle(`taskproject${row.index}`)}
                          className={`${styles['hover-employee-div']} hover-employee-tooltip`}
                        >
                          {
                          this.state.associatedTasks &&  this.state.associatedTasks[`project${row.index}`] && this.state.associatedTasks[`project${row.index}`] !== 'Loading...' ?
                           this.state.associatedTasks && this.state.associatedTasks[`project${row.index}`] && this.state.associatedTasks[`project${row.index}`].length ? this.state.associatedTasks[`project${row.index}`].map((item,index)=>
                              <li>{item}</li>
                              )
                            :
                              <li>No records</li>
                           :
                           <li>{this.state.associatedTasks && this.state.associatedTasks[`project${row.index}`] ? this.state.associatedTasks[`project${row.index}`] : null}</li>
                        }
                        </Tooltip>
                      </div>
                    </div>
                    );
                }
              },
              {
                Header: row => {return (
                    <SortHeaderComponent project_sorting="tags_count">TAGS COUNT</SortHeaderComponent>
                  )},
                accessor: "tags_count",
                id:"tags_count",
                sortable: false,
                width: this.widthToHeader.tags_count,
                show: this.state.showableAttributes.tags_count,
                headerClassName: 'text-right pr-4',
                Cell: row => {
                    if(row.original.total == true){
                      return (
                        <div>{row.original.tags_count}</div>
                      );
                    }
                    return (
                    <div key={`tagsproject${row.index}`} className={`${styles['employee-div']} pr-4`}>
                      <div
                        tabIndex="0"
                        id={`tagsproject${row.index}`}
                        onMouseOver={()=>this.getTagsList(row.original.id,row.index)}
                        className={`hover-employee-tooltip-div link-name d-inline-block`}
                        style={{width:'20%', cursor:'default'}}
                      >
                        <b role="button">{row.original.tags_count}</b>
                        <Tooltip
                          placement="left"
                          isOpen={this.isToolTipOpen(`tagsproject${row.index}`)}
                          autohide={false} 
                          hideArrow={false}
                          target={`tagsproject${row.index}`}
                          toggle={() => this.popToggle(`tagsproject${row.index}`)}
                          className={`${styles['hover-employee-div']} hover-employee-tooltip`}
                        >
                          {
                          this.state.associatedTags && this.state.associatedTags[`project${row.index}`] && this.state.associatedTags[`project${row.index}`] !== 'Loading...' ?
                          this.state.associatedTags&&  this.state.associatedTags[`project${row.index}`] && this.state.associatedTags[`project${row.index}`].length ? this.state.associatedTags[`project${row.index}`].map((item,index)=>
                              <li>{item}</li>
                              )
                            :
                              <li>No records</li>
                           :
                           <li>{this.state.associatedTags && this.state.associatedTags[`project${row.index}`] ? this.state.associatedTags[`project${row.index}`] : null}</li>
                          }
                        </Tooltip>
                      </div>
                    </div>
                  );
                }
              },
              {
                Header: row => {return (
                    <SortHeaderComponent project_sorting="hours">ACTUAL HOURS</SortHeaderComponent>
                  )},
                accessor: 'hours',
                width: this.widthToHeader.hours,
                sortable: false,
                id: 'hours',
                show: this.state.showableAttributes.hours,
                headerClassName: 'text-right pr-4',
                Cell: row => {
                    if(row.original.total == true){
                      return (
                        <div className={`${styles['total-hours-color']} cursor-pointer text-right pr-4`} onClick={() => this.setData({ data: row.original, group_by: "job" },"totals")}>{row.original.hours_display}</div>
                      );
                    }
                    return (
                      <div
                        tabIndex="0"
                        className="link-name text-right pr-4"
                        style={{cursor:'default'}}
                      >
                       <b className="d-inline-block" role="button" onClick={() => this.setData({ data: row.original, group_by: "job" })}>{row.original.hours_display}</b>
                      </div>
                    );
                }
              },
              {
                Header: row => {return (
                    <SortHeaderComponent project_sorting="total_budget_hour">BUDGETED HOURS</SortHeaderComponent>
                    )},
                accessor: 'total_budget_hour',
                width: this.widthToHeader.total_budget_hour,
                sortable: false,
                id: 'total_budget_hour',
                show: this.state.showableAttributes.total_budget_hour,
                headerClassName: 'text-right pr-4',
                Cell: row => {
                  if(row.original.total == true){
                    return (
                      <div className="text-right pr-4">{row.original.total_budget_hour > 0 ? row.original.total_budget_hour : 0}</div>
                    );
                  }
                  if (row.original.total_budget_hour === 0 || row.original.total_budget_hour > 0) {
                    return (
                      <div className="text-right pr-4">{row.original.total_budget_hour.toFixed(2)}</div>
                    );
                  }
                  return null;
                }
              },
              {
                Header: row => {return (
                    <SortHeaderComponent project_sorting="total_quoted_amount">QUOTED AMOUNT</SortHeaderComponent>
                    )},
                accessor: 'total_quoted_amount',
                width: this.widthToHeader.total_quoted_amount,
                sortable: false,
                id: 'total_quoted_amount',
                show: this.state.showableAttributes.total_quoted_amount,
                headerClassName: 'text-right pr-4',
                Cell: row => {
                  if(row.original.total == true){
                    return (
                      <div className="text-right pr-4">{row.original.total_quoted_amount > 0 ? row.original.total_quoted_amount : 0}</div>
                    );
                  }
                  if (row.original.total_quoted_amount === 0 || row.original.total_quoted_amount > 0) {
                    return (
                      <div className="text-right pr-4">{row.original.total_quoted_amount.toFixed(2)}</div>
                    );
                  }
                  return null;
                }
              },
              {
                Header: row => {return (
                    <SortHeaderComponent project_sorting="labour_cost">LABOR COST</SortHeaderComponent>
                    )},
                accessor: 'labour_cost',
                width: this.widthToHeader.labour_cost,
                sortable: false,
                id: 'labour_cost',
                show: this.state.showableAttributes.labour_cost,
                headerClassName: 'text-right pr-4',
                Cell: row => {
                  if(row.original.total == true){
                    return (
                      <div className="text-right pr-4">{row.original.labour_cost > 0 ? row.original.labour_cost : 0}</div>
                    );
                  }
                  if (row.original.labour_cost === 0 || row.original.labour_cost > 0) {
                    return (
                      <div className="text-right pr-4">{row.original.labour_cost.toFixed(2)}</div>
                    );
                  }
                  return null;
                }
              },
              {
                Header: row => {return (
                     <SortHeaderComponent project_sorting="labour_ratio">LABOR RATIO (%)</SortHeaderComponent>
                    )},
                accessor: 'labour_ratio',
                sortable: false,
                width: this.widthToHeader.labour_ratio,
                id:'labour_ratio',
                show: this.state.showableAttributes.labour_ratio,
                headerClassName: 'text-right pr-4',
                Cell: row => {
                  if(row.original.total == true){
                    return (
                      <div className="text-right pr-4">{row.original.labour_ratio}</div>
                    );
                  }
                  return <div className="text-right pr-4">{ row.original.labour_ratio }</div>
                }
              },
              {
                Header: 'STATUS',
                accessor: 'status',
                width: this.widthToHeader.status,
                sortable: false,
                id: 'status',
                show: this.state.showableAttributes.status,
                Cell: row => {
                  if(row.original.total == true){
                    return null;
                  }
                  if (row.original.start_date_display && row.original.bill_type==="QUOTED" && row.original.job_type==="PROJECT") {
                    return (
                      <div>
                        <div id={`a${row.original.id}`} className='d-inline-block tooltip-override-div'>
                          <span className="link-name" role="button" tabIndex={0} onClick={() => this.props.togglePopOver("quotedProject",row.original.id, row.original)}>{row.original.status}</span>
                        </div>
                      </div>
                    );
                  }
                  return null;
                }
              },
            ]}
          />
        </Collapse>
      </div>
    )
  }
}


QuotedProjectCustomerTable.propTypes = {
  location: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  loading: PropTypes.bool,
};

QuotedProjectCustomerTable.contextTypes = {
  router: PropTypes.object.isRequired,
};

export default QuotedProjectCustomerTable;